export default __webpack_public_path__ + "flag-black-shape.png";